import Head from './../components/Head.vue';
import { getUrlParams } from '@/plugins/utils';
import Footer from '../components/Footer.vue';
export default {
  components: {
    Head,
    Footer
  },

  created() {
    this.training_plan_page();
  },

  mounted() {},

  data() {
    return {
      menuId: this.$utils.getUrlParams('menuId'),
      yearList: [{
        grade: 2023
      }],
      checkYear: '',
      input4: '',
      college: [{
        organName: '船舶工程学院',
        list: ['船舶与海洋工程', '港口航道与海岸工程', '海洋机器人']
      }, {
        organName: '航天与建筑工程学院',
        list: ['工程力学', '土木工程', '飞行器设计与工程']
      }, {
        organName: '动力与能源工程学院',
        list: ['能源与动力工程', '轮机工程']
      }, {
        organName: '船舶工程学院',
        list: ['船舶与海洋工程', '港口航道与海岸工程', '海洋机器人']
      }, {
        organName: '航天与建筑工程学院',
        list: ['工程力学', '土木工程', '飞行器设计与工程']
      }, {
        organName: '动力与能源工程学院',
        list: ['能源与动力工程', '轮机工程']
      }],
      oddList: [],
      //单数
      evenList: [] //双数

    };
  },

  methods: {
    //打开文件
    openFile(college) {
      // window.open(`https://www.zhihuishu.com/columnsapp/student/previewPDF.html?url=${college.url}`)
      window.open(`/pdfPreview.html?url=${college.url}`);
    },

    initCollege() {
      this.college.length && this.college.forEach((item, i) => {
        if ((i + 1) % 2 == 0) {
          this.evenList.push(item);
        } else {
          this.oddList.push(item);
        }
      });
    },

    async training_plan_page() {
      let res = await this.$http.training_plan_page({
        type: 2
      });

      if (res) {
        this.yearList = res.splice(0, 4);
        this.checkYear = this.yearList[0].grade;
        this.training_plan_list(this.yearList[0].grade, this.input4);
      }
    },

    async training_plan_list(grade, keyword) {
      this.oddList = [];
      this.evenList = [];
      let list = await this.$http.training_plan_list({
        grade,
        keyword
      });

      if (list) {
        console.log('aaaaa');
        this.college = list;
        this.initCollege();
      }
    },

    changeYear(grade) {
      this.checkYear = grade;
      this.training_plan_list(grade, this.input4);
    }

  }
};